<div id="exportar-pdf">
  <section>
    <app-cabecalho-relatorio></app-cabecalho-relatorio>
    <app-rotulo-cabecalho [cliente]="relatorio?.cabecalho?.nomeCliente"
      [contrato]="relatorio?.cabecalho?.contratoCliente" [cnpj]="relatorio?.cabecalho?.cnpjCliente"
      [tipoDeContrato]="relatorio?.cabecalho?.tipoContratoCliente"
      [mesReferencia]="relatorio?.cabecalho?.vencimento?.mesReferencia"
      [vencimento]="relatorio?.cabecalho?.vencimento?.vencimentoRel"
      [faturaNumero]="relatorio?.cabecalho?.vencimento?.numeroFatura" [valor]="relatorio?.cabecalho?.valorFatura"
      [dataEmissao]="relatorio?.cabecalho?.vencimento?.dataEmissao"
      [emissao]="relatorio?.cabecalho?.vencimento?.emissao"></app-rotulo-cabecalho>
  </section>
  <div *ngFor="let detalhe of relatorio?.detalhamento">
    <app-tabela-relatorio [equipamento]="detalhe?.nomeEquipamento"
      [cabecalhosTabela]="['PATRIMÔNIO', 'DESCRIÇÃO', 'ANT. P&B', 'ATU. P&B', 'SALDO P&B', 'VALOR EXC. P&B', 'ANT COR', 'ATU COR', 'SALDO COR', 'VALOR EXC. COR', 'DATA LEIT.', 'CONTATO']"
      >
      <tr *ngFor="let detalhesTabela of detalhe.informacoesTabela">
        <ng-container class="cabecalho__tabela">
          <td class="item__tabela">{{ detalhesTabela.patrimonio }}</td>
          <td class="item__detalhamento">{{ detalhesTabela.equipamento }}</td>
          <td class="item__tabela">{{ detalhesTabela.antPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.atuPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.saldoPB }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorExcPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.antCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.atuCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.saldoCor }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorExcCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.dataLeit | date: "dd/MM/yyyy" }}</td>
          <td class="item__tabela">{{ detalhesTabela.contato }}</td>
        </ng-container>
      </tr>
    </app-tabela-relatorio>
    <div>
      <app-rodape-tabela-relatorios [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo"
        [subtotalModeloPb]="detalhe?.pb" [subtotalModeloCor]="detalhe?.cor">
      </app-rodape-tabela-relatorios>
    </div>
  </div>
    <app-rodape-relatorio [valorTotalDaFatura]="relatorio?.cabecalho?.valorFatura"
      [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo">
      <div class="resumo__total">
        <div>
          <span class="titulo__resumo">FRANQUIAS CONTRATADAS</span>
          <app-tabela-relatorio
            [apareceOuNao]="false" [cabecalhosTabela]="['FRANQUIA', 'PÁGINAS', 'VALOR']" >
          </app-tabela-relatorio>
          <div>
            <div class="tabela__franquias">
              <div class="itens__combo">
                <span class="titulo__resumo__item">P&B: </span>
                <p class="informacao__dado"> {{ relatorio?.resumoTotal?.franquias?.franquiaPB }} </p>
                <p class="informacao__dado"> R$ {{relatorio?.resumoTotal?.franquias?.valorFranqPB }} </p>
              </div>
              <div class="itens__combo">
                <span class="titulo__resumo__item">COLOR: </span>
                <p class="informacao__dado">  {{ relatorio?.resumoTotal?.franquias?.franquiaCor }}</p>
                <p class="informacao__dado"> R$ {{relatorio?.resumoTotal?.franquias?.valorFranqCor }}</p>
              </div>
            </div>
            <div>
              <div class="itens__combo">
                <span class="titulo__resumo__item">VALOR: </span>
                <p class="informacao__dado"> R$ {{relatorio?.resumoTotal?.franquias?.valorTotalFranquia }}</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <span class="titulo__resumo">IMPRESSÕES PRODUZIDAS</span>
          <div class="itens__combo">
            <div class="itens__combo__cima">
              <span class="titulo__resumo__item">P&B: </span>
              <p class="informacao__dado"> {{ relatorio?.resumoTotal?.impressoesProduzidas?.pb }} </p>
            </div>
          </div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">COLOR: </span>
            <p class="informacao__dado"> {{ relatorio?.resumoTotal?.impressoesProduzidas?.cor }}</p>
          </div>
        </div>
        <div>
          <span class="titulo__resumo">IMPRESSÕES EXCEDENTES</span>
          <div class="itens__combo">
            <div class="itens__combo__cima">
              <span class="titulo__resumo__item">P&B: </span>
              <p class="informacao__dado"> {{ relatorio?.resumoTotal?.impressoesExcedentes?.pb }} </p>
            </div>
          </div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">COLOR: </span>
            <p class="informacao__dado"> {{ relatorio?.resumoTotal?.impressoesExcedentes?.cor }}</p>
          </div>
        </div>
        <div>
          <span class="titulo__resumo">VALOR EXCEDENTE</span>
          <div class="itens__combo">
            <div class="itens__combo__cima">
              <span class="titulo__resumo__item">P&B: </span>
              <p class="informacao__dado"> R$ {{ relatorio?.resumoTotal?.valorExcedente?.pb }} </p>
            </div>
          </div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">COLOR: </span>
            <p class="informacao__dado"> R$ {{ relatorio?.resumoTotal?.valorExcedente?.cor }}</p>
          </div>
        </div>
      </div>
    </app-rodape-relatorio>
